/* eslint-disable prettier/prettier */
const prod = {
  REDIRECT_LOGOUT_URL: 'https://dash.cliengo.com/login',
  API_URL: 'https://api.cliengo.com/1.0',
  METRICS_API_URL: 'https://geniol-1b70ca157962.herokuapp.com',
  MFE_APP_GENIA_HOME: 'https://prod.d1txpjwjyslsew.amplifyapp.com',
  ZORDON_URL: 'https://zordon-8487db5d9dca.herokuapp.com/api',
  MFE_APP_REPORTS_URL: 'https://www.custom-report.cliengo.com/?r=advanced',
  MFE_APP_LIVE_URL: 'https://kanban.cliengo.com',
  MFE_IFRAME_CRM: 'https://crm.cliengo.com',
  MFE_IFRAME_HSM: 'https://www.hsm-manager.cliengo.com',
  MFE_APP_CAMPAIGNS_URL: 'https://campaigns.cliengo.com',
  MFE_APP_GENIA_CHATBOT_MODULE: 'https://chatbot-module.cliengo.com',
  MFE_IFRAME_COCOS: 'https://www.coquitos.cliengo.com',
  MFE_ACCOUNT: 'https://account.cliengo.com',
  SOCKET_NOTIFICATION_URL: 'https://socketia-68064d93baa5.herokuapp.com/clients',
  SEGMENT_WRITE_KEY: process.env.PROD_SEGMENT_WRITE_KEY,
  LAUNCHDARKLY_KEY: process.env.PROD_LAUNCHDARKLY_KEY,
  IA_URL: 'https://zordon-8487db5d9dca.herokuapp.com/api/message/receive',
  MFE_TS_AI_REPORTS_URL: "https://appsmith.devcliengo.com/app/gpt-report-csat/dashboard-6532697f36a60447071ed1f9?embed=true&companyId=",
  ADMIN_URL: "https://app.cliengo.com/admin/companies",
  LIA_URL: 'https://lw.cliengo.com/?companyId=64c02796ab1bdd003206c656&websiteId=64c153b4b18b27005d0e0c9f',
  MFE_APP_DASHBOARD_URL: 'https://dashboard.cliengo.com',
  MFE_APP_AFFILIATES: 'https://www.partners-dashboard.cliengo.com',
  CLIENGO_APP_URL: 'https://app.cliengo.com',
  CRM_URL: 'https://crm.cliengo.com',
  LW_URL: 'https://lw.cliengo.com',
  COOKIE_DOMAIN: '.cliengo.com',
  MFE_APP_SUBSCRIPTIONS_URL: 'https://subscriptions.cliengo.com',
  ONESIGNAL_APP_ID: 'e4874139-e530-4598-b4f4-771bb891f3b3',
  LOGIN_URL: 'https://login.cliengo.com',
};

export default prod;
